import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Location } from '@era/locations-sdk';
import {
  PlacementArray,
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap';
import { RouteLinkInput } from '@era/app';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'era-select-location-list-ui',
  templateUrl: './select-location-list.component.html',
  styleUrls: ['./select-location-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink],
})
export class SelectLocationListComponent {
  @Input() public locations: Location[];
  @Input() public location: Location;

  @Input() public header = false;
  @Input() public route: RouteLinkInput;
  @Input() public placeholder: string;
  @Input() public placement: PlacementArray;
}
